import { IStep } from './multistep.interface';

export const disableBackBtn = (currentStep: number) => currentStep === 1;
export const disableNextBtn = (currentStep: number, steps: IStep[]) => currentStep === steps.length;
